import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/beyond-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Beyond Poshmark - 10 Online Marketplaces For Your Pre-loved Clothes and Items</title>
        <meta
          name='description'
          content='Over the years, e-commerce witnessed incredible growth. In 2021, the e-commerce sales in the US alone reached $870 billion, which is 50.5% higher than the sales from 2019. Given public health and safety concerns, nearly 47% of adults changed their shopping behavior. Online marketplaces have been the go-to destinations for both essential needs and leisure items.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/beyond-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/beyond-poshmark' />
        <meta
          property='og:title'
          content='Beyond Poshmark - 10 Online Marketplaces For Your Pre-loved Clothes and Items'
        />
        <meta
          property='og:description'
          content='Over the years, e-commerce witnessed incredible growth. In 2021, the e-commerce sales in the US alone reached $870 billion, which is 50.5% higher than the sales from 2019. Given public health and safety concerns, nearly 47% of adults changed their shopping behavior. Online marketplaces have been the go-to destinations for both essential needs and leisure items.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
